import React from 'react';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormTextField extends SMFormFieldBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      value : this.props.value ? this.props.value : "",
    };
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.value != this.props.value) {
      this.setState({
        value : nextProps.value,
      });
    }
  }
  
  didFocus(e) {
  }
  
  didBlur(e) {
    if (this.isChange) {
      if(this.props.delegate && typeof this.props.delegate.textFieldDidEndEditing === 'function'){
        this.props.delegate.textFieldDidEndEditing(e);
      }
    }
    this.isChange = false;
  }
  
  didChangeValue(e) {
    this.isChange = true;
    this.setState({value: e.currentTarget.value});
  }

  render() {
    
    const fieldClassName = this.errorFieldClassName("form-text", this.props.errorText);
    
    return (
        <input type={this.props.type}
          name={this.state.name} 
          value={this.state.value} 
          max={this.props.max} 
          min={this.props.min} 
          className={fieldClassName + ' ' + this.props.options.className} 
          placeholder={this.props.placeholderText}
          onChange={this.didChangeValue.bind(this)} 
          onFocus={this.didFocus.bind(this)} 
          onBlur={this.didBlur.bind(this)}
          disabled={this.props.options.disabled}
           />
    );
  }
}
SMFormTextField.defaultProps = {
  type: "text",
  options: {
    className: "w147",
    disabled: false,
  }
};
export default SMFormTextField;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormTextField.jsx